import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Bell, CheckCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function AccountNotifications() {
  const { reloadUnread } = useOutletContext();
  const [items, setItems] = useState(null);
  const load = () => api.get("/client/notifications").then(({ data }) => setItems(data.notifications)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await api.post("/client/notifications/read", { all: true }); load(); reloadUnread && reloadUnread(); };
  const markOne = async (id) => { await api.post("/client/notifications/read", { id }); load(); reloadUnread && reloadUnread(); };

  return (
    <div className="space-y-6" data-testid="account-notifications">
      <div className="flex items-center justify-between gap-4">
        <div><p className="kicker mb-1">My Ascendia</p><h1 className="font-display text-2xl sm:text-3xl font-semibold text-white">Notifications</h1></div>
        <button onClick={markAll} data-testid="mark-all-read" className="inline-flex items-center gap-2 rounded-xl border border-[color:var(--border-subtle)] px-4 py-2.5 text-sm text-white/80 hover:bg-white/5"><CheckCheck className="h-4 w-4" /> Mark all read</button>
      </div>
      {items === null ? <p className="text-sm text-muted-c">Loading…</p> : items.length === 0 ? (
        <div className="ascendia-card p-10 text-center"><Bell className="h-8 w-8 text-gold-soft mx-auto" /><p className="mt-4 text-white font-medium">You're all caught up</p><p className="mt-1 text-sm text-muted-c">Updates about your quotes, bookings and reports will appear here.</p></div>
      ) : (
        <div className="space-y-2" data-testid="notifications-list">
          {items.map((n) => (
            <button key={n.id} onClick={() => !n.read_at && markOne(n.id)} className={`w-full text-left ascendia-card p-4 flex items-start gap-3 ${!n.read_at ? "border-[color:var(--border-strong)]" : "opacity-70"}`}>
              <span className={`mt-0.5 h-2 w-2 flex-shrink-0 rounded-full ${!n.read_at ? "bg-gold" : "bg-white/20"}`} />
              <div className="flex-1"><p className="text-sm font-medium text-white">{n.title}</p><p className="text-sm text-muted-c mt-0.5">{n.body}</p><p className="text-[11px] text-muted-c mt-1">{(n.created_at || "").slice(0, 16).replace("T", " ")}</p></div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
